// index.js
import React from 'react';
import ReactDOM from 'react-dom/client'; // for React 18+
import App from './App'; // your main App component
import './index.css'; // optional: global styles

// Create root and render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
